import React from "react"
import styled from "styled-components"

import Box from "components/atoms/Box"

const StyledBox = styled(Box)`
  position: relative;
  width: 100%;
  &:after {
    content: "";
    display: block;
    padding-bottom: ${props => props.$ratio};
  }
`

// Ratio = height / width, automatically changes height based on width
const ProportionalBox = ({ children, ratio, ...rest }) => {
  return (
    <StyledBox $ratio={`${ratio * 100}%`} {...rest}>
      <Box position="absolute" height="100%" width="100%">
        {children}
      </Box>
    </StyledBox>
  )
}

ProportionalBox.defaultProps = {
  overflow: "hidden",
  ratio: 0.5625,
}

ProportionalBox.propTypes = {
  ...Box.propTypes,
}

export default ProportionalBox
